export default __webpack_public_path__ + "static/grega-a6098c1359790f7e45d66def75732a0f.png";